export default __webpack_public_path__ + "ad8ae8b17b123bffb8f44d5d283c42c3.svg";